// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2qUwM","additionalInfo":"AgreementModal_additionalInfo__1Ss4x"};